import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/services/user/user.service'
import { HttpClient } from '@angular/common/http'
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';

@Component({
  selector: 'app-wok',
  templateUrl: './wok.component.html',
  styleUrls: ['./wok.component.scss']
})
export class WokComponent implements OnInit {

  windowsAppUrl: string = 'https://kryptomon-assets.ams3.cdn.digitaloceanspaces.com/installers/kryptomon-world-of-kogaea-prod-latest.exe';// 'https://kryptomon-assets.ams3.cdn.digitaloceanspaces.com/installers/kryptomon-world-of-kogaea-prod-latest.exe';
  androidAppUrl: string = 'https://play.google.com/store/apps/details?id=com.kryptomon.world';// 'https://play.google.com/store/apps/details?id=com.kryptomon.world';
  appleAppUrl: string = 'https://testflight.apple.com/join/Nx5zl25z';// 'https://testflight.apple.com/join/Nx5zl25z';
  isDisabled: boolean = false;
  constructor(private router: Router, private userService: UserService, private http: HttpClient, private toastService: ToastService) { }

  ngOnInit(): void {
    // this.router.navigate(['kryptomons']);
  }

  whitelist() {
    let post = {
      walletAddress: this.userService._userInfoData.recordedWallet
    }
    this.http.post("https://api.kryptomon.co/wok-community/autoWhitelist.php", post).subscribe((item) => {
      this.toastService.add({
        severity: 'success',
        summary: 'shared.success',
        detail: 'Your account is now whitelisted!',
      });
    }, (err) => {
      this.toastService.genericError()
    })
  }

}
